import { CountryIsoCode } from "../../enums/CountryISOCode";

export default class Company {
  readonly id: string;

  readonly name?: string;

  readonly countryIsoCode: CountryIsoCode;

  constructor({
    id = "",
    name = "",
    countryIsoCode = CountryIsoCode.SPAIN,
  }: {
    id: string;
    name?: string;
    countryIsoCode?: CountryIsoCode;
  }) {
    this.id = id;
    this.name = name;
    this.countryIsoCode = countryIsoCode;
  }
}
